// ============================================================
// MANIC MEETER — Static markup text
// ============================================================
// index.html carries the German wording as a no-JavaScript fallback; every one
// of those nodes is tagged with data-i18n and overwritten from the active
// locale at boot and on every language switch.

import { C } from "./i18n";

/** Walk a dot path into the UI strings. Returns undefined for anything but a string. */
function lookup(path: string): string | undefined {
  let node: unknown = C().ui;
  for (const key of path.split(".")) {
    if (typeof node !== "object" || node === null) return undefined;
    node = (node as Record<string, unknown>)[key];
  }
  return typeof node === "string" ? node : undefined;
}

/** Rebuild the instructions screen from the locale — the sections differ per language. */
function renderInstructions(): void {
  const host = document.getElementById("instructions-sections");
  if (!host) return;
  host.innerHTML = C().ui.instructions.sections
    .map(
      (section) => `
        <div class="instr-section">
          <h3>${section.heading}</h3>
          ${section.paragraphs.map((p) => `<p>${p}</p>`).join("")}
        </div>`,
    )
    .join("");
}

/** Apply every data-i18n binding in the document. Safe to call repeatedly. */
export function applyStaticText(): void {
  document.documentElement.lang = C().htmlLang;

  for (const el of Array.from(document.querySelectorAll<HTMLElement>("[data-i18n]"))) {
    const text = lookup(el.dataset.i18n!);
    if (text !== undefined) el.textContent = text;
  }
  for (const el of Array.from(document.querySelectorAll<HTMLElement>("[data-i18n-title]"))) {
    const text = lookup(el.dataset.i18nTitle!);
    if (text !== undefined) el.title = text;
  }
  for (const el of Array.from(document.querySelectorAll<HTMLInputElement>("[data-i18n-placeholder]"))) {
    const text = lookup(el.dataset.i18nPlaceholder!);
    if (text !== undefined) el.placeholder = text;
  }

  const langBtn = document.getElementById("lang-toggle");
  if (langBtn) langBtn.textContent = C().ui.controls.langSwitchLabel;

  renderInstructions();
}
